module.exports = __webpack_public_path__ + "img/14.f0f6d28b.png";